import React, { useEffect } from 'react';
import EquipsComponents from './EquipsComponents';
import { useDispatch, useSelector } from 'react-redux';
import { getEquipamentosAr } from '../../slices/productSlice';

const Equipamentos = ({ maquinarioId }) => {
  const dispatch = useDispatch();
  const { equipamentos } = useSelector((state) => state.product);
  useEffect(() => {
    dispatch(getEquipamentosAr(maquinarioId));
  }, [maquinarioId]);

  return (
    <>
      {equipamentos &&
        Object.entries(equipamentos).map(([key, item], index) => (
          <EquipsComponents item={item} key={index} />
        ))}
    </>
  );
};

export default Equipamentos;
